
//FIXME: the badge library needs to be ripped out a replaced by a separate component that also gets re-used if possible

//NOTE TO SELF, API for stage uses stagenum, NOT primary key.
//NOTE TO SELF, API often uses itempk in URL. This is item.id, which is NOT an item record itself, but the badge id (item_id column)

var ProgramDesigner = function(options){
    var oThis = this;

    oThis.defaults = {
        programID: null,
        orgID: null,
        view_mode: false
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );

    oThis.apiRoot = buildRoute(mantlroutes.program, { orgid: oThis.settings.orgID, programid: oThis.settings.programID });
    oThis.Actions = Reflux.createActions(['fetchSettings,','fetchProgram','fetchBadges','fetchBadgeDetails','renameProgram','setProgramStatus','addStage','saveStage','removeStage','addBadge','removeBadge','addStagePrerequisite','removeStagePrerequisite']);
    oThis.containerID;
    oThis.modalsID = "programModals";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //React components
    //Settings
    oThis.ProgramDesignerSettings = createReactClass({
        mixins: [Reflux.connect(oThis.ProgramSettingsStore, 'settingsstore')],

        handleSwitch: function(bIsOn) {
            oThis.Actions.setProgramStatus(bIsOn);
        },

        componentDidMount: function() {
            var oComponent = this;
            var $settings = $(ReactDOM.findDOMNode(this));
            $settings.on('change','.switch',function(){
                var bIsOn = $(this).prop( "checked" );
                oComponent.handleSwitch(bIsOn);
            });
            $settings.find('[data-popover=tooltip]').tooltip();
            //Workaround for JSX not supporting custom attributes
            $settings.attr("row","row");
            $settings.find(">div").eq(0).attr("column","8");
            $settings.find(">div").eq(1).attr("column","4");

            //editable program name
            var $name = $("#programName");
            if(!oThis.settings.view_mode){
                $name.editable({
        			"placeholder" : "No description.",
                    "label" : "Program Name",
        			"newLineOnEnterKey" : false, //if false, enter key will blur/save the field
        			"onSave" : function(oEditable){
                        oThis.Actions.renameProgram(oEditable);
        			}
        		});
            }
        },

        componentDidUpdate: function() {
            var oComponent = this;
            var $settings = $(ReactDOM.findDOMNode(this));
            $settings.find('[data-popover=tooltip]').tooltip();

            //editable program name
            var $name = $("#programName");
            if(!oThis.settings.view_mode){
                $name.editable({
        			"placeholder" : "No description.",
                    "label" : "Program Name",
        			"newLineOnEnterKey" : false, //if false, enter key will blur/save the field
        			"onSave" : function(oEditable){
                        oThis.Actions.renameProgram(oEditable);
        			}
        		});
            }
        },


        render: function() {

            if(this.state.settingsstore){
                //var created = Date.parse(new Date(this.state.settingsstore.created)).toString('MMM dS, yyyy');
                var created = fecha.format(new Date(this.state.settingsstore.created), 'MMM Do, YYYY');
                var live = this.state.settingsstore.live;
                var active = this.state.settingsstore.active_learners
                return (
                    <header className="program-header row">
                        <div>
                            <h2 id="programName">{this.state.settingsstore.name}</h2>
                            {(function(){
                                if (active > 0) {
                                    return (<p><span className="flag flag--badged">{active}</span> Active Learners</p>);
                                }
                            })()}
                            <p>Created by <b>{this.state.settingsstore.created_by.user.full_name}</b> on {created}</p>
                        </div>
                        <div className="text--right h2-controls">
                            <b data-popover="tooltip" title="If a program is live and has active learners, it cannot be turned off.">Program is Live</b>
                            {(function(){
                                if (live && active == 0 && !oThis.settings.view_mode) {
                                    //switch on, unlocked
                                    return (<span><input type="checkbox" id="programLive" className="switch switch--small cond1" defaultChecked aria-hidden="false" /><label htmlFor="programLive" className="switch-label" title="Program is Live">Program is Live</label></span>);
                                } else if (live && active > 0 || live && oThis.settings.view_mode) {
                                    //switch on, disabled
                                    return (<span><input type="checkbox" id="programLive" className="switch switch--small cond2" disabled="disabled" defaultChecked aria-hidden="false" /><label htmlFor="programLive" className="switch-label" title="Program is Live">Program is Live</label></span>);
                                } else if (!live && oThis.settings.view_mode) {
                                    //switch off, disabled
                                    return (<span><input type="checkbox" id="programLive" className="switch switch--small cond3" disabled="disabled" aria-hidden="false" /><label htmlFor="programLive" className="switch-label" title="Program is Live">Program is Live</label></span>);
                                } else {
                                    //switch off, unlocked
                                    return (<span><input type="checkbox" id="programLive" className="switch switch--small cond4" aria-hidden="false" /><label htmlFor="programLive" className="switch-label" title="In Draft Mode">Program is Live</label></span>);
                                }
                            })()}
                        </div>
                    </header>
                );

            } else {
                return (
                    <header className="program-header">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </header>
                );
            }

        }
    });

    //Program Designer
    oThis.ProgramDesignerEditor = createReactClass({
        mixins: [Reflux.connect(oThis.ProgramStore, 'programstore')],

        render: function() {
            if(this.state.programstore){
                var stages = [];
                for(var i = 1; i < this.state.programstore.length + 1; i++){
                    var oStage = _.find(this.state.programstore, ['order',i]); //we can't rely on api response being sorted by order value
                    var oNextStage = _.find(this.state.programstore, ['order',i+1]),
                    nNextStageID = 0;
                    if(oNextStage != undefined) {
                        nNextStageID = oNextStage.id;
                    }
                    stages.push(<oThis.ProgramDesignerStage stage={oStage} key={oStage.id} order={oStage.order} nextstageid={nNextStageID} />);
                }
                //<div className="program-stage-add"><oThis.ProgramDesignerAddStage afterorder={this.props.order} /></div>
                if(stages.length > 0){
                    return (
                        <div className="program">
                            <div id={oThis.modalsID}></div>
                            {stages}
                            <oThis.ProgramDesignerBadgeLibraryBar />
                        </div>
                    );
                } else {
                    //Brand new or empty, has no stages
                    var afterorder = 0;
                    return (
                        <div className="program">
                            <div id={oThis.modalsID}></div>
                            <div className="program-stage-add"><oThis.ProgramDesignerAddStage afterorder={afterorder} /></div>
                        </div>
                    );
                }

            } else {
                return (
                    <div className="program"><div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div></div>
                );
            }

        }
    });

    //Stage
    oThis.ProgramDesignerStage = createReactClass({

        handleRemoveStage: function() {
            var oComponent = this;
            alertify.okBtn("Remove Stage").cancelBtn("Cancel").confirm("<h1 class='h3'>Are you sure you want to remove stage number " + this.props.order + "?</h1><p>This can't be undone.</p>")
            .then(function (resolvedValue) {
                // "resolvedValue" is an object with the following keys: buttonClicked and event
                resolvedValue.event.preventDefault();

                if(oComponent.props.stage.chains.length > 0 && resolvedValue.buttonClicked == "ok"){
                    //Double-check
                    alertify.okBtn("Yes, I'm Sure").cancelBtn("Cancel").confirm("<h1 class='h3 text--danger'>Are you really sure?</h1><p>This stage contains badges.</p>")
                    .then(function (resolvedValue) {
                        // "resolvedValue" is an object with the following keys: buttonClicked and event
                        resolvedValue.event.preventDefault();
                        if(resolvedValue.buttonClicked == "ok"){
                            oThis.Actions.removeStage(oComponent.props.order);
                        }
                    })
                } else if(resolvedValue.buttonClicked == "ok"){
                    oThis.Actions.removeStage(oComponent.props.order);
                }

            });

        },

        componentDidMount: function() {
            var stage = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            dragscroll( stage.find(".program-stage")[0] );
            var $description = $(".program-stage[data-order=" + this.props.order + "] .program-stage-description");

            if(!oThis.settings.view_mode){
                $description.editable({
        			"placeholder" : "No description.",
        			"newLineOnEnterKey" : false, //if false, enter key will blur/save the field
        			"onFocus" : function(oEditable){
        			    //console.log("editable focus")
        			},
        			"onBlur" : function(oEditable){
                        //console.log("editable blur")
        			},
        			"onSave" : function(oEditable){
                        //console.log("save onSave");
                        var data = {
                            "description": oEditable.content
                        }
                        httpPatch(oThis.apiRoot + "stage/" + oComponent.props.order, data).then(
                            function(value){
                                //console.log(JSON.parse(value));
                                //Even though the UI is correct we need to update the store otherwise a re-draw will replace its content.
                                var oResponse = JSON.parse(value);
                                alertify.success("Stage description saved.");

                                oThis.Actions.saveStage(oResponse);
                            })
                        .catch(
                            function(reason) {
                                alertify.error("Unable to save stage description." );

                                oEditable.revert();
                            });
        			}
        		});
            }

        },

        render: function() {
                var oComponent = this;
                var chains = [];
                var addStage, prereqs;
                for(var i = 1; i < this.props.stage.chains.length + 1; i++){
                    var oChain = _.find(this.props.stage.chains, ['order',i]); //we can't assume api response being sorted by order value
                    chains.push(<oThis.ProgramDesignerChain chain={oChain} root={0} key={oChain.order} stageid={this.props.stage.id} nextstageid={this.props.nextstageid} />); //treating root 0 like null
                }

                if (this.props.order > 1) {
                    prereqs = <oThis.ProgramDesignerStagePrerequisites stage={this.props.stage} />;
                } else {
                    prereqs = null;
                }

                addStage = null;
                if (this.props.order == oThis.ProgramStore.program.length && !oThis.settings.view_mode) { //add stage only at bottom
                    addStage = <div className="program-stage-add"><oThis.ProgramDesignerAddStage afterorder={this.props.order} /></div>;
                }

                return (
                    <div className="program-stage-wrapper">
                        {prereqs}
                        <section className="program-stage" data-order={this.props.order} data-id={this.props.stage.id}>
                            <p><span className="flag program-stage-number"><i className="icon-cube"></i> Program Stage {this.props.stage.order}
                            {(function(){
                                if (!oThis.settings.view_mode) {
                                    return (<button className="program-stage-delete" onClick={oComponent.handleRemoveStage} title="Delete Stage from Program" data-popover="tooltip" data-delay="750" aria-label="Delete Stage from Program"><i className="icon-close"></i></button>);
                                }
                            })()}
                                </span> <span className="program-stage-description">{this.props.stage.description}</span></p>
                            <ul className="program-badges">{chains}
                                {(function(){
                                    if (!oThis.settings.view_mode) {
                                        return (<oThis.ProgramDesignerAddBadge stageid={oComponent.props.stage.id} />);
                                    }
                                })()}
                            </ul>
                            {addStage}
                        </section>
                    </div>
                );
            }
        });

    //Chain of Badge Nodes
    //nodes are program items in database
    oThis.ProgramDesignerChain = createReactClass({

        render: function() {
            var oComponent = this;
            var childnodes = [];
            var oRoot;
            //console.log(this.props.chain.nodes);
            if(this.props.chain.nodes != null && this.props.chain.nodes.length > 0){
                if(this.props.root == 0) {
                    oRoot = _.find(this.props.chain.nodes, ['prerequisite',null]);
                } else {
                    oRoot = _.find(this.props.chain.nodes, ['id',this.props.root]);
                }

                for(var i = 0; i < this.props.chain.nodes.length; i++){
                    var oNode = this.props.chain.nodes[i];
                    if (oNode.prerequisite == oRoot.id){
                        childnodes.push(<oThis.ProgramDesignerChain chain={this.props.chain} root={oNode.id} key={oNode.id} stageid={this.props.stageid} nextstageid={this.props.nextstageid} />);
                    }
                }
            }

            //console.log(oRoot, this.props.stageid, childnodes.length);

            if(childnodes.length > 0){
                return (
                    <li>
                        <oThis.ProgramDesignerBadge stageid={this.props.stageid} nodes={this.props.chain.nodes} view_url={oRoot.url} badge={oRoot.item} nextstageid={this.props.nextstageid} library={false} />
                        <ul className="program-badges">
                            {childnodes}
                            {(function(){
                                if (!oThis.settings.view_mode) {
                                    return (<oThis.ProgramDesignerAddBadge stageid={oComponent.props.stageid} parent={oRoot.item.id} parentName={oRoot.item.name} />);
                                }
                            })()}
                        </ul>
                    </li>
                );
            } else {
                return (
                    <li>
                        <oThis.ProgramDesignerBadge stageid={this.props.stageid} nodes={this.props.chain.nodes} view_url={oRoot.url} badge={oRoot.item} nextstageid={this.props.nextstageid} library={false} />
                        <ul className="program-badges">
                            {(function(){
                                if (!oThis.settings.view_mode) {
                                    return (<oThis.ProgramDesignerAddBadge stageid={oComponent.props.stageid} parent={oRoot.item.id} parentName={oRoot.item.name} />);
                                }
                            })()}
                        </ul>
                    </li>

                );
            }

        }
    });


    //Badge Card
    oThis.ProgramDesignerBadge = createReactClass({
        handleFlip: function(e) {
            e.stopPropagation();
            var $badge = $(ReactDOM.findDOMNode(this));
            $badge.toggleClass("is-flipped");
            if( $badge.hasClass("is-flipped")){
                oThis.Actions.fetchBadgeDetails(this.props.badge.id, $badge);
            }
        },

        handleSwitch: function(bIsOn) {
            //TODO remote the rat's nest below for the switch and turn into a separate component
            var $badge = $(ReactDOM.findDOMNode(this));
            if(bIsOn) {
                oThis.Actions.addStagePrerequisite(this.props.nextstageid,this.props.badge.id);
            } else {
                oThis.Actions.removeStagePrerequisite(this.props.nextstageid,this.props.badge.id);
            }

        },

        handleDelete: function() {
            //var $badge = $(ReactDOM.findDOMNode(this));
            oThis.Actions.removeBadge(this.props.badge.id,this.props.stageid,this.props.nextstageid);
        },

        handleHighlight: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var bLibrary = this.props.library || false;
            if(bLibrary) {
                $badge.closest(".modal").find(".badge--highlighted").removeClass("badge--highlighted");
                $badge.addClass("badge--highlighted");
            }
        },

        handleViewDetails: function(e) {
            //Build Modal
            httpGet(this.props.view_url).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Badge Details"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading item details.', reason);
                    alertify.error('Unable to Open Program Item')
                });
        },

        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            if(!this.props.library){
                $badge.addClass("animated boingInUp");
            }
            setTimeout(function(){ $badge.removeClass("animated boingInUp"); },1100);

            $badge.on('change','.switch',function(){
                var bIsOn = $(this).prop( "checked" );
                oComponent.handleSwitch(bIsOn);
            });

            $badge.on('click','.badge-details',function(){
                oComponent.handleViewDetails();
            });

            $('[data-popover="tooltip"]',ReactDOM.findDOMNode(this)).tooltip();
        },

        componentDidUpdate: function() {
            //reset the badge
            var $badge = $(ReactDOM.findDOMNode(this));
            $badge.removeClass("is-flipped").find(".badge-back-content").empty();
            $(".badge--highlighted").removeClass("badge--highlighted");
        },
        render: function() {
            var oComponent = this;
            var nextstageid = this.props.nextstageid || 0;
            var bLibrary = this.props.library || false;
            var bCanDelete = false;
            var prerequisite = null;
            if(this.props.nodes){
                prerequisite = _.find(this.props.nodes, function(a) { return a.item.id == oComponent.props.badge.id; }).prerequisite || null;
            }
            var checkbox = "prereqswitch_" + this.props.badge.id; //important, this prereq is for the next stage, which uses badge PKs, not program item PKs (but "item" in the node refers to a badge record)
            var bIsPrereq = false;
            var oNextStage = _.find(oThis.ProgramStore.program, ['id',nextstageid]);
            if(oNextStage != undefined) {
                if(oNextStage.prerequisites != undefined && oNextStage.prerequisites.length > 0) {
                    for(var i = 0; i < oNextStage.prerequisites.length; i++) {
                        if(oNextStage.prerequisites[i].item.id == this.props.badge.id){
                            bIsPrereq = true;
                        }
                    }
                }
            }
            if(prerequisite == null && bLibrary == false) {
                //check if it has children. Root nodes with children can't be removed (for now)
                if(this.props.nodes.length == 1){
                    bCanDelete = true;
                }
            } else if (prerequisite != null && bLibrary == false) {
                bCanDelete = true;
            }


            return (
                <figure className="badge" data-badge-id={this.props.badge.id} data-badge-details={this.props.badge.url} onClick={this.handleHighlight}>
                    <div className="badge-face badge-front">
                        <figcaption className="badge-name">{this.props.badge.name}</figcaption>
                        <button className="badge-flip" title="See Details" onClick={this.handleFlip} aria-label="See Details"><i className="icon-rotate-left"></i></button>
                        <img className="badge-art" src={this.props.badge.image} title="Badge Art"></img>
                        <p className="badge-flags">
                            {(function(){
                                if (bCanDelete && !oThis.settings.view_mode) {
                                  return (<button className="badge-delete" onClick={oComponent.handleDelete} title="Delete Stage Item" data-popover="tooltip" data-delay="750" aria-label="Delete Stage Item"><i className="icon-close"></i></button>);
                                }
                            })()}
                            <span className="badge-flag badge-flag--internal" data-popover="tooltip" title="Aligned Internal Outcomes"><i className="icon-map-marker"></i> {this.props.badge.internal_outcomes}</span>
                            <span className="badge-flag badge-flag--external" data-popover="tooltip" title="Aligned External Outcomes"><i className="icon-map-marker"></i> {this.props.badge.internal_outcomes}</span>
                            {(function(){
                                if(oThis.settings.view_mode){
                                    if(nextstageid != 0 && bIsPrereq && !bLibrary){
                                        return (<span className="badge-flag" data-popover="tooltip" title="Prerequisite for Next Stage"><i className="icon-sitemap icon--success"></i> Required</span>);
                                    }
                                } else {
                                    if (nextstageid != 0 && !bIsPrereq && !bLibrary) {
                                        return (<span><input type="checkbox" id={checkbox} className="switch switch--small" aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" data-popover="tooltip" data-delay="750" title="Prerequisite for Next Stage">Prerequisite for Next Stage</label></span>);
                                    } else if (nextstageid != 0 && bIsPrereq && !bLibrary) {
                                        return (<span><input type="checkbox" id={checkbox} className="switch switch--small" defaultChecked aria-hidden="false" /><label htmlFor={checkbox} className="switch-label" data-popover="tooltip" data-delay="750" title="Prerequisite for Next Stage">Prerequisite for Next Stage</label></span>);
                                    }
                                }
                            })()}
                        </p>
                        {/* <span className="flag badge-id" title="Badge ID">{this.props.badge.id}</span> */}
                    </div>
                    <div className="badge-face badge-back">
                        <button className="badge-flip" onClick={this.handleFlip} title="Hide Details" aria-label="Hide Details"><i className="icon-rotate-right"></i></button>
                        <div className="badge-back-content">
                            <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                        </div>
                    </div>

                </figure>
            );

        }
    });

    //Library Bar Badge
    oThis.ProgramDesignerLibraryBadge = createReactClass({

        handleHighlight: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            $(".library-badge.badge--highlighted").removeClass("badge--highlighted");
            $badge.addClass("badge--highlighted");
        },

        handleViewDetails: function(e) {
            //Build Modal
            httpGet(this.props.view_url).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Badge Details"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading item details.', reason);
                    alertify.error('Unable to Open Program Item')
                });
        },

        componentDidMount: function() {
            var $badge = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',ReactDOM.findDOMNode(this)).tooltip();
        },

        componentDidUpdate: function() {
            //reset the badge
            var $badge = $(ReactDOM.findDOMNode(this));
            $(".badge--highlighted").removeClass("badge--highlighted");
        },
        render: function() {
            var oComponent = this;
            return (
                <figure className="library-badge keyboard-draggable" tabIndex={0} data-badge-id={this.props.badge.id} data-badge-details={this.props.badge.url} onClick={this.handleHighlight}>
                    <figcaption className="library-badge-name flag flag--badged" title={this.props.badge.name}>{this.props.badge.name}</figcaption>
                    <div className="library-badge-art"><img src={this.props.badge.image} alt={this.props.badge.name}></img></div>
                    <button className="button--sm button--faint button--skinny" onClick={this.handleViewDetails}><i className="icon-eye" aria-label="Details"></i> Details</button>
                </figure>
            );

        }
    });


    //Stage Prereqs
    oThis.ProgramDesignerStagePrerequisites = createReactClass({

        handleClick: function(e) {

        },

        componentDidMount: function() {
            var $prereq = $(ReactDOM.findDOMNode(this))
            var aPrereqs = this.props.stage.prerequisites;
            $prereq.tooltip();
            $prereq.on('mouseenter',function(){
                $prereq.tooltip();
                for(var i = 0; i < aPrereqs.length; i++){
                    $(".badge[data-badge-id=" + aPrereqs[i].item.id + "]").addClass("animated animated--infinite pulse badge--highlighted");
                }
            }).on('mouseleave',function(){
                $(".badge.badge--highlighted").removeClass("animated animated--infinite pulse badge--highlighted");
            });
        },

        componentDidUpdate: function() {
            var $prereq = $(ReactDOM.findDOMNode(this));
            var aPrereqs = this.props.stage.prerequisites;
            $prereq.on('mouseenter',function(){
                $prereq.tooltip();
                for(var i = 0; i < aPrereqs.length; i++){
                    $(".badge[data-badge-id=" + aPrereqs[i].item.id + "]").addClass("animated animated--infinite pulse badge--highlighted");
                }
            }).on('mouseleave',function(){
                $(".badge.badge--highlighted").removeClass("animated animated--infinite pulse badge--highlighted");
            });
        },

        componentWillUnmount: function() {
        },

        render: function() {
            var sID = "prereqs_" + this.props.stage.id;
            if(this.props.stage.prerequisites != undefined && this.props.stage.prerequisites.length > 0){
                return (<div className="program-stage-prerequisites" id={sID} data-stage={this.props.stage.id} data-popover="tooltip" data-placement="right" data-original-title="Has Stage Prerequisites" title="Has Stage Prerequisites"><i className="icon-lock"></i></div>);
            } else {
                return (<div className="program-stage-prerequisites" id={sID} data-stage={this.props.stage.id} data-popover="tooltip" data-placement="right" data-original-title="No Stage Prerequisites" title="No Stage Prerequisites"><i className="icon-check icon--success"></i></div>);
            }

        }
    });


    //Add Badge Action
    oThis.ProgramDesignerAddBadge = createReactClass({

        handleClick: function(e) {
            var parent = this.props.parent || 0;
            var stageID = this.props.stageid

            //ReactDOM.render(<oThis.ProgramDesignerBadgeLibraryModal parent={this.props.parent} stageid={this.props.stageid} />, document.getElementById(oThis.modalsID));
            //So that we can dynamically set contents, ARIA, and other functions we manually trigger the modal instead of binding by the class hook
            /*$("#badgeLibraryModal").attr({
                "aria-labelledby": "TODO",
                "role": "dialog",
                "tabindex" : "-1",
                "data-savetarget" : this.props.parent
            }).openModal();*/

            if($(".library-badge.badge--highlighted").length > 0) {
                var newBadgeID = parseInt($(".library-badge.badge--highlighted").data("badge-id"));
                oThis.Actions.addBadge(newBadgeID, stageID, parent);
                $(".library-badge.badge--highlighted").removeClass("badge--highlighted");
            } else {
                alertify.warning("You must select an item in the library first.");
            }

        },

        componentDidMount: function() {
            var oComponent = this;
            $('[data-popover="tooltip"]',ReactDOM.findDOMNode(this)).tooltip();
            var $add = $(ReactDOM.findDOMNode(this));
            var $badge = $(".badge[data-badge-id=" + this.props.parent + "]");
            $add.hover(function(){
                $badge.addClass("badge--highlighted animated pulse");
            },
            function(){
                $badge.removeClass("badge--highlighted animated pulse");
            });

            //drag drop
            // enable draggables to be dropped into this
            interact('.program-badge-add', { context: $add.parent('li')[0] }).dropzone({
                // only accept elements matching this CSS selector
                accept: '.library-badge.drag-clone',
                // Require a 75% element overlap for a drop to be possible
                overlap: 0.4,

                // listen for drop related events:

                ondropactivate: function (event) {
                    // add active dropzone feedback
                    //console.log('ondropactivate',event);
                    event.target.classList.add('is-dropzone');
                },
                ondragenter: function (event) {
                    //console.log('ondragenter',event);
                    var draggableElement = event.relatedTarget,
                    dropzoneElement = event.target;
                    // feedback the possibility of a drop
                    dropzoneElement.classList.add('is-drop-target');
                    draggableElement.classList.add('can-drop');
                },
                ondragleave: function (event) {
                    //console.log('ondragleave',event);
                    // remove the drop feedback style
                    event.target.classList.remove('is-drop-target');
                    event.relatedTarget.classList.remove('can-drop');
                },
                ondrop: function (event) {
                    //console.log('ondrop',event);
                    var $dropped = $(event.relatedTarget);
                    var $target = $(event.target);

                    //add new badge to program if it's not there already
                    var newBadgeID = parseInt($dropped.data("badge-id")),
                        stageID = parseInt($target.data("stage")),
                        parentBadgeID = parseInt($target.data("parent")),
                        oStage = _.find(oThis.ProgramStore.program, ['id',stageID]),
                        bAlreadyThere = false;

                    for(var i = 0; i < oThis.ProgramStore.program.length; i++){
                        for(var j = 0; j < oThis.ProgramStore.program[i].chains.length; j++){
                            for(var k = 0; k < oThis.ProgramStore.program[i].chains[j].nodes.length; k++){
                                if(oThis.ProgramStore.program[i].chains[j].nodes[k].item.id == newBadgeID) {
                                    bAlreadyThere = true;
                                }
                            }
                        }
                    }

                    if(!bAlreadyThere){
                        oThis.Actions.addBadge(newBadgeID, stageID, parentBadgeID);
                    } else {
                        alertify.error("This badge is already in the program.");
                    }

                },
                ondropdeactivate: function (event) {
                    //console.log('ondropdeactivate',event);
                    // remove active dropzone feedback
                    event.target.classList.remove('is-dropzone');
                    event.target.classList.remove('is-drop-target');
                }
            });
        },
        //pass this a prop for the parent/context
        render: function() {
            var parent = this.props.parent || 0;
            var parentName = this.props.parentName || "Stage";
            var addTitle;
            if(parent == 0){
                addTitle = "Add Selected Library Badge to Start of " + parentName;
            } else {
                addTitle = "Add Selected Library Badge After " + parentName;
            }

            if(oThis.settings.view_mode){
                return(<li></li>); //safety net
            } else {
                return (<li className="program-badge-add" data-stage={this.props.stageid} data-parent={parent}><button data-stage={this.props.stageid} data-parent={parent} data-popover="tooltip" data-placement="bottom" title={addTitle} aria-label={addTitle} onClick={this.handleClick}><i className="icon-plus icon--tiny icon--spaced"></i><i className="icon-shield icon--larger"></i></button></li>);
            }
        }
    });


    //Add Stage Action
    oThis.ProgramDesignerAddStage = createReactClass({

        handleAddStage: function() {
            oThis.Actions.addStage(this.props.afterorder);
        },

        //pass this a prop for the parent/context
        render: function() {
            return (<button className="button--full button--primary button--lg" onClick={this.handleAddStage} data-afterorder={this.props.afterorder} aria-label="Add Stage"><i className="icon-plus icon--tiny icon--spaced icon--success"></i><i className="icon-cubes"></i> Add Stage</button>);
        }
    });


    oThis.ProgramDesignerBadgeLibraryModal = createReactClass({

        getInitialState: function() {
            return {
                badges: [],
                count: 0,
                params: {
                    page: 1,
                    page_size: 6,
                    published: true
                }
            };
        },

        handleSave: function(e) {

            var parentBadgeID = this.props.parent;
            var stageID = this.props.stageid;
            var newBadgeID = parseInt($("#badgeLibraryModal").find(".badge--highlighted").attr("data-badge-id"));


            var oStage = _.find(oThis.ProgramStore.program, ['id',stageID]);
            var bAlreadyThere = false;
            for(var i = 0; i < oThis.ProgramStore.program.length; i++){
                for(var j = 0; j < oThis.ProgramStore.program[i].chains.length; j++){
                    for(var k = 0; k < oThis.ProgramStore.program[i].chains[j].nodes.length; k++){
                        if(oThis.ProgramStore.program[i].chains[j].nodes[k].item.id == newBadgeID) {
                            bAlreadyThere = true;
                        }
                    }
                }
            }

            if(!bAlreadyThere){
                oThis.Actions.addBadge(newBadgeID, stageID, parentBadgeID);
            } else {
                alertify.error("This badge is already in the program.");
            }


        },

        handleFetchBadges: function(){
            var oComponent = this;
            var endpoint = buildRoute(mantlroutes.org_badges, { orgid: oThis.settings.orgID });
            var params = oComponent.state.params;
            var url = endpoint + formatParams(params)

            httpGet(url).then(
                // Use the fulfillment value
                function(value) {
                    //console.log(JSON.parse(value));
                    var response = JSON.parse(value);
                    oComponent.setState({
                        badges: response.results,
                        count: response.count
                    });
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error fetching badge library.', reason);
                });
        },

        handlePagePrevious: function(){
            if(this.state.params.page > 1) {
                this.state.params.page--;
            }
            this.handleFetchBadges();
        },

        handlePageNext: function(){
            this.state.params.page++;
            this.handleFetchBadges();
        },

        handleFilter: function(){
            var oComponent = this;
            this.state.params.page = 1;
            this.state.params.date_from = $("#date_from").val();
            this.state.params.date_to = $("#date_to").val();
            this.state.params.skill = $("#skills").val();
            this.state.params.program = $("#badgeProgram").val();
            this.handleFetchBadges();
        },

        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            this.handleFetchBadges();
            $('.collapsible',$component).collapsible();

            var pickerFrom = new Pikaday({
                field: document.getElementById("date_from"),
                defaultDate: new Date()
            });
            var pickerTo = new Pikaday({
                field: document.getElementById("date_to"),
                defaultDate: new Date()
            });
            var typeaheadTags = typeaheads.skillTagsList("#skills");
            var typeaheadPrograms = typeaheads.orgPrograms("#badgeProgram");
        },

        componentWillUnmount: function() {
        },

        render: function() {
            var oComponent = this;
            var badges = [];
            var bShowPrevious = this.state.params.page > 1;
            var bShowNext = (this.state.params.page * this.state.params.page_size) < this.state.count;

            this.state.badges.forEach(function(oBadge,index){
                badges.push(<oThis.ProgramDesignerBadge view_url={oBadge.url} badge={oBadge} library={true} />);
            });

            return (
                <div id="badgeLibraryModal" className="modal modal--flat modal--full">
                    <div className="modal-container">
                        <div className="modal-header">
                            Badge Library
                            <a href="#close" className="modal-close">&times;</a>
                        </div>

                        <div className="modal-body">
                            <ul className="collection collapsible" data-collapsible="expandable">
                                <li className="collection-item">
                                    <button className="collapsible-header" aria-label="Filters"><Icon classes="icon-filter"></Icon> Filters</button>
                                    <div className="collapsible-body">

                                        <label>Filter by Date Created</label>
                                        <div className="form--inline">
                                            <div className="input-group">
                                                <label htmlFor="date_from" className="input-prefix input-prefix--date">From</label>
                                                <input type="text" id="date_from" name="date_from" className="datepicker" />
                                            </div>
                                            <div className="input-group">
                                                <label htmlFor="date_to" className="input-prefix input-prefix--date">To</label>
                                                <input type="text" id="date_to" name="date_to" className="datepicker" />
                                            </div>
                                            <div className="input-group">
                                                <label htmlFor="skills" className="input-prefix">Filter by Skills</label>
                                                <select multiple id="skills"></select>
                                            </div>
                                            <div className="input-group">
                                                <label htmlFor="badgeProgram" className="input-prefix">Intended Program</label>
                                                <input type="text" name="program" id="badgeProgram"></input>
                                            </div>
                                        </div>

                                        <p className="input--actions"><button className="button--primary button--sm" onClick={oComponent.handleFilter} aria-label="Apply Filters"><i className="icon-check"></i> Apply Filters</button></p>

                                    </div>
                                </li>
                            </ul>
                            <div className="badge-grid badge-grid--fluid clearfix" id="badgeLibraryGrid">
                                {badges}
                            </div>
                            <p className="text--center">
                                {(function(){
                                    if (bShowPrevious) {
                                        return (<button className="button--sm button--flat" onClick={oComponent.handlePagePrevious} aria-label="Previous">Previous</button>);
                                    } else {
                                        return (<button className="button--sm button--skinny" disabled="disabled">Previous</button>);
                                    }
                                })()}
                                {(function(){
                                    if (bShowNext) {
                                        return (<button className="button--sm button--flat" onClick={oComponent.handlePageNext} aria-label="Next">Next</button>);
                                    } else {
                                        return (<button className="button--sm button--skinny" disabled="disabled">Next</button>);
                                    }
                                })()}
                            </p>
                        </div>

                        <div className="modal-footer">
                            <p><button className="button--primary" onClick={this.handleSave} aria-label="Add Badge">Add Badge</button></p>
                        </div>
                    </div>
                </div>
            );
        }
    });

    //TODO: make bar detect which "add" targets are legal
    oThis.ProgramDesignerBadgeLibraryBar = createReactClass({

        getInitialState: function() {
            //var $library = $(ReactDOM.findDOMNode(this));
            var count = $();
            //console.log($library, $library.width(), count);
            return {
                badges: [],
                count: 0,
                params: {
                    page: 1,
                    page_size: Math.floor($(window).width()/170),
                    published: true
                }
            };
        },

        handleFetchBadges: function(){
            var oComponent = this;
            var endpoint = buildRoute(mantlroutes.org_badges, { orgid: oThis.settings.orgID });
            var params = oComponent.state.params;
            var url = endpoint + formatParams(params);

            httpGet(url).then(
                // Use the fulfillment value
                function(value) {
                    //console.log(JSON.parse(value));
                    var response = JSON.parse(value);
                    oComponent.setState({
                        badges: response.results,
                        count: response.count
                    });
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error fetching badge library.', reason);
                });
        },

        handlePagePrevious: function(){
            if(this.state.params.page > 1) {
                this.state.params.page--;
            }
            var $library = $(ReactDOM.findDOMNode(this));
            var count = Math.floor($library.width()/175);
            this.state.params.page_size = count;
            this.handleFetchBadges();
        },

        handlePageNext: function(){
            this.state.params.page++;
            this.handleFetchBadges();
        },

        handleChangePage: function(page) {
            this.setState({
                params: $.extend(true, {}, this.state.params, { page: page } )
            });
        },

        handleFilter: function(){
            var oComponent = this;
            this.state.params.page = 1;
            this.state.params.pattern = $("#pattern").val();
            this.state.params.date_from = $("#date_from").val();
            this.state.params.date_to = $("#date_to").val();
            this.state.params.skill = $("#skills").val();
            this.state.params.program = $("#badgeProgram").val();
            this.handleFetchBadges();
        },

        componentDidUpdate: function(prevProps, prevState){
            if(prevState.params.page != this.state.params.page){
                this.handleFetchBadges();
            }
        },

        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;

            $('body').addClass('has-library');
            $(".drawer-trigger","#programLibraryBar").drawer();
            this.handleFetchBadges();

            var pickerFrom = new Pikaday({
                field: document.getElementById("date_from"),
                defaultDate: new Date()
            });
            var pickerTo = new Pikaday({
                field: document.getElementById("date_to"),
                defaultDate: new Date()
            });
            var typeaheadTags = typeaheads.skillTagsList("#skills");
            var typeaheadPrograms = typeaheads.orgPrograms("#badgeProgram");


            var resizeLibraryPage = debounce(function() {
                var count = Math.floor($(window).width()/175);
                if(count < 4) { count = 4; }
                //figure out the position to set the page (so the same first badge shows)
                var firstBadge = 1 + (oComponent.state.params.page_size * (oComponent.state.params.page - 1));
                var newPage = Math.ceil(firstBadge/count);
                oComponent.state.params.page = newPage;
                oComponent.state.params.page_size = count;
                oComponent.handleFetchBadges();
            }, 250);
            $(window).on("resize", function(){
                resizeLibraryPage();
            });

        },

        componentWillUnmount: function() {
        },
        
        getInitialState: function () {
            return {
                badges: [],
                count: 0,
                params: { page: 1, page_size: Math.floor($(window).width() / 170), published: true },
                open: false
            };
        },

        render: function() {
            var oComponent = this;
            var badges = [];
            var bShowPrevious = this.state.params.page > 1;
            var bShowNext = (this.state.params.page * this.state.params.page_size) < this.state.count;
            var totalPages = 1;
            totalPages = Math.ceil(this.state.count / this.state.params.page_size);
            var visiblePages = 3;
            var visiblePages = (totalPages < 4) ? totalPages : 4;
            this.state.badges.forEach(function(oBadge,index){
                badges.push(<oThis.ProgramDesignerLibraryBadge view_url={oBadge.url} badge={oBadge} key={index} />);
            });

            return (

                <div className="program-library drawer" id="programLibraryBar">
                     <button
                        type="button"
                        className="button--sm button--skinny program-library-toggle drawer-trigger"
                        data-drawer="#programLibraryBar"
                        aria-label="Toggle Badge Library"
                        aria-expanded={this.state.open ? "true" : "false"}
                        aria-controls="programLibraryBar"
                        onClick={() => this.setState({ open: !this.state.open })}
                    >
                        <i className="icon-chevron-down drawer-trigger-icon" aria-hidden="true"></i>
                        Badge Library
                    </button>

                    <div className="drawer-content">
                        <div className="program-library-filters">

                            <div className="row">
                                <div className="column-2 column-sm-12 column-md-6">
                                    <label htmlFor="pattern" title="Search by Name">&nbsp;<i className="icon-search" title="Search by Name"></i> Badge Title</label>
                                    <input type="search" className="input--underline" id="pattern" name="pattern" title="Name Contains" placeholder="Contains..." />
                                </div>
                                <div className="column-3 column-sm-6 column-md-6">
                                    <label htmlFor="skills" className="input-prefix">Filter by Skills</label>
                                    <select multiple id="skills"></select>
                                </div>
                                <div className="column-2 column-sm-6 column-md-6">
                                    <label htmlFor="badgeProgram" className="input-prefix">Program Set</label>
                                    <input type="text" name="program" id="badgeProgram"></input>
                                </div>
                                <div className="column-2 column-sm-6 column-md-3">
                                    <label htmlFor="date_from" className="input-prefix input-prefix--date" title="Date Created From">Created From</label>
                                    <input type="text" id="date_from" name="date_from" className="datepicker input--underline" />
                                </div>
                                <div className="column-2 column-sm-6 column-md-3">
                                    <label htmlFor="date_to" className="input-prefix input-prefix--date" title="Date Created To">To</label>
                                    <input type="text" id="date_to" name="date_to" className="datepicker input--underline" />
                                </div>
                                <div className="column-1 column-sm-12 column-md-12">
                                    <button className="button--success button--full button--skinny submit--inline" onClick={oComponent.handleFilter} aria-label="Find"><i className="icon-check"></i> Find</button>
                                </div>
                            </div>
                        </div>

                        <div className="program-library-badges">
                            <div className="badge-grid badge-grid--fluid clearfix" id="badgeLibraryGrid">
                                {badges}
                            </div>
                            <p className="text--center" style={{ marginBottom: '4px' }}><small>{oComponent.state.count} badges found.</small></p>
                            <div className="text--center">
                                <TablePagination max={totalPages} maxVisible={visiblePages} onChange={oComponent.handleChangePage}/>
                            </div>
                        </div>
                    </div>
                </div>

            );
        }
    });

};

ProgramDesigner.prototype.renderSettings = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.ProgramDesignerSettings />, document.getElementById(this.containerID));
}

ProgramDesigner.prototype.renderItems = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.ProgramDesignerEditor />, document.getElementById(this.containerID));
}

//REFLUX STORE
ProgramDesigner.prototype.createStore = function() {
    var oThis = this;

    //Settings are in a different store because the API doesn't return all of meta info when getting items
    //TODO: refactor naming to better reflect api namespacing
    oThis.ProgramSettingsStore = Reflux.createStore({
        listenables: oThis.Actions,
        settings: {}, //live,creator,date created etc

        init: function() {
        },

        getInitialState: function() {
            this.onFetchSettings();
        },

        onFetchSettings: function() {
            var oStore = this;
            httpGet(oThis.apiRoot).then(
                function(value) {
                    oStore.settings = JSON.parse(value);
                    oStore.trigger(oStore.settings);
                })
            .catch(
                function(reason) {
                    console.error('Error loading program settings.', reason);
                    alertify.log('Error loading program settings')
                });

        },

        onRenameProgram: function(oEditable) {
            var oStore = this;
            var data = {
                "name": oEditable.content
            }
            httpPatch(oThis.apiRoot, data).then(
                function(value){
                    //console.log(JSON.parse(value));
                    var newSettings = JSON.parse(value);
                    oStore.settings = newSettings;
                    oStore.trigger(oStore.settings);

                    alertify.success("Program Renamed");
                })
            .catch(
                function(reason) {
                    alertify.error("Unable to save program name.");
                    oEditable.revert();
                });
        },

        onSetProgramStatus: function(bIsOn) {
            var oStore = this;
            var data = { live: bIsOn };

            httpPatch(oThis.apiRoot, data).then(
                function(value){
                    //console.log(JSON.parse(value))
                    var newSettings = JSON.parse(value);
                    oStore.settings = newSettings;
                    oStore.trigger(oStore.settings);

                    alertify.success("Program Live Status Saved");
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error changing program live setting.', reason);
                    //since it failed, we need to flip the switch back off so the UI matches the state of data
                    $("#programLive").prop( "checked", !bIsOn);
                    alertify.error("Unable to set live status to " + bIsOn + ". ");
                });
        }

    });

    oThis.ProgramStore = Reflux.createStore({
        listenables: oThis.Actions,
        program: {}, //program items

        init: function() {
            //this.onFetchProgram();
        },

        getInitialState: function() {
            //return this.program;
            this.onFetchProgram();
        },

        onFetchProgram: function() {

            var oStore = this;
            httpGet(oThis.apiRoot + "items/").then(
                function(value) {
                    //console.log(JSON.parse(value))
                    oStore.program = JSON.parse(value);
                    oStore.trigger(oStore.program);
                })
            .catch(
                function(reason) {
                    console.error('Error loading program items.', reason);
                });

        },

        onFetchBadges: function(target, viewonly) {

        },

        onAddBadge: function(newBadgeID, stageID, parentBadgeID) {
            var oStore = this;
            var oStage = _.find(oStore.program, ['id',stageID]);
            var nStageIndex = _.findIndex(oStore.program, ['id',stageID]);

            var data = {
                "item": null,
                "order": null
            }
            data.item = newBadgeID;
            if(parentBadgeID > 0){
                data.prerequisite = parentBadgeID;
            }

            httpPost(oThis.apiRoot + "stage/" + oStage.order + "/item/", data).then(
                function(value){
                    var oNode = JSON.parse(value);
                    //console.log(JSON.parse(value));

                    if(oNode.prerequisite == null){
                        oThis.Actions.fetchProgram(); //if it has no prerequisite, then it creates a new chain and it's safer to just re-get the full program JSON
                    } else {
                        for(var i = 0; i < oStore.program[nStageIndex].chains.length; i++){
                            var nParentIndex = _.findIndex(oStore.program[nStageIndex].chains[i].nodes, ['id',oNode.prerequisite.id]);
                            if(nParentIndex > -1){
                                //hackish, because prereqs returned here are more complex
                                oNode.prerequisite = oNode.prerequisite.id;
                                oStore.program[nStageIndex].chains[i].nodes.push(oNode);
                                oStore.trigger(oStore.program);
                            }
                        }
                    }

                    $("#badgeLibraryModal").closeModal();
                    alertify.success("Badge Added");
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error adding new badge.', reason);
                    alertify.error("Unable to add badge to stage. " );
                });

        },

        onRemoveBadge: function(nItemID, stageID, nextStageID) {
            var oStore = this;
            var oStage = _.find(oStore.program, ['id',stageID]);

            alertify
                .okBtn("Remove Badge")
                .cancelBtn("Cancel")
                .confirm("Are you sure you want to remove this badge?", function (event) {
                    // The click event is in the event variable if we need it
                    //e.g. event.preventDefault();

                    ///DELETE org/4/program/15/stage/1/item/248
                    httpDelete(oThis.apiRoot + "stage/" + oStage.order + "/item/" + nItemID).then(
                        function(value){
                            //system doesn't currently automatically delete the stage prereq.
                            oThis.Actions.removeStagePrerequisite(nextStageID,nItemID);
                            oThis.Actions.fetchProgram(); //deleting might result in a major shift in chains and root nodes
                            alertify.success("Badge Removed");
                        })
                    .catch(
                        // Log the rejection reason
                        function(reason) {
                            console.error('Error removing badge.', reason);
                            alertify.error("Unable to remove badge from stage.");
                        });

                });



        },

        onFetchBadgeDetails: function(nBadgeID, $badge) {
            //console.log("fetch details for " + nBadgeID)
            var $badge = $badge || $(".badge[data-badge-id="+nBadgeID+"]");
            var $backContent = $badge.find(".badge-back-content");

            httpGet(buildRoute(mantlroutes.api_badge, { badgeid: nBadgeID })).then(
                function(value){
                    value = JSON.parse(value);
                    //console.log(value);
                    if(value.description.length == 0){
                        value.description = "<i>No description.</i>";
                    }
                    $backContent.empty().append("<p class='badge-description'>" + value.description + "</p>");

                    if(value.tags.length == 0){
                        $backContent.append("<p>No skills linked to badge.</p>");
                    } else {
                        $tags = $("<div class='badge-skills' />");
                        for(var i = 0; i < value.tags.length; i++) {
                            $tags.append("<span class='flag flag--badged'>" + value.tags[i] + "</span>");
                        }
                        $backContent.append($tags);
                    }

                    $backContent.append("<p><button class='button button--pill button--sm badge-details' aria-label='Full Details'>Full Details</button></p>");

                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error retrieving badge details.', reason);
                });

        },

        onAddStage: function(afterorder) {
            var oStore = this;
            var afterorder = afterorder || oStore.program.length;
            var neworder = afterorder + 1;

            alertify.okBtn("Add").cancelBtn("Cancel").defaultValue("No description.").prompt("Please give the new stage a description.", function (val, ev) {
                    // The click event is in the event variable, so you can use it here.
                    ev.preventDefault()
                    var data = {
                        "order": neworder,
                        "description": val
                    }

                    httpPost(oThis.apiRoot + "stage/", data).then(
                        function(value){
                            var oStage = JSON.parse(value);
                            oStage.chains = [];
                            oStore.program.push(oStage);
                            oStore.trigger(oStore.program);
                            alertify.success("Stage Added");
                        })
                    .catch(
                        // Log the rejection reason
                        function(reason) {
                            console.error('Error adding new stage.', reason);
                            alertify.error("Unable to add stage to program.");
                        });

                }, function(ev) {
                  // The click event is in the event variable, so you can use it here.
                  ev.preventDefault();
                  alertify.log("Stage Not Added");
                }
            );

        },

        onSaveStage: function(oResponse) {
            var oStore = this;
            var nStageIndex = _.findIndex(oStore.program, ['id',oResponse.id]);
            oStore.program[nStageIndex].description = oResponse.description;
        },

        onRemoveStage: function(order) {
            //DELETE
            var oStore = this;
            httpDelete(oThis.apiRoot + "stage/" + order).then(
                function(value){
                    oStore.onFetchProgram();
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error removing stage.', reason);
                    alertify.error("Unable to remove stage from program.");
                });
        },

        onAddStagePrerequisite: function(nStageID,nBadgeID) {
            var oStore = this;
            var nStageIndex = _.findIndex(this.program, ['id', nStageID]);
            var oStage = this.program[nStageIndex];
            var data = { item: nBadgeID };

            httpPost(oThis.apiRoot + "stage/" + oStage.order + "/prerequisite/", data).then(
                function(value){
                    oStore.program[nStageIndex].prerequisites.push(JSON.parse(value));
                    oStore.trigger(oStore.program);
                })
            .catch(
                // Log the rejection reason
                function(reason) {
                    console.error('Error adding stage prerequisite.', reason);
                    //since it failed, we need to flip the switch back off so the UI matches the state of data
                    $("[data-badge-id=" + nBadgeID + "]").find("input[type=checkbox]").prop( "checked", false);
                    alertify.error("Unable to set badge as stage prerequisite. ");
                });

        },

        onRemoveStagePrerequisite: function(nStageID,nBadgeID) {
            var oStore = this;
            var nStageIndex = _.findIndex(this.program, ['id', nStageID]);
            var oStage = this.program[nStageIndex];
            var nPrereqIndex = _.findIndex(this.program[nStageIndex].prerequisites, function(a) { return a.item.id == nBadgeID; });

            if(nPrereqIndex != -1) {
                httpDelete(oThis.apiRoot + "stage/" + oStage.order + "/prerequisite/" + nBadgeID).then(
                    function(value){
                        oStore.program[nStageIndex].prerequisites.splice(nPrereqIndex,1);
                        oStore.trigger(oStore.program);
                    })
                .catch(
                    // Log the rejection reason
                    function(reason) {
                        console.error('Error deleting stage prerequisite.', reason);
                        $("[data-badge-id=" + nBadgeID + "]").find("input[type=checkbox]").prop( "checked", true);
                        alertify.error("Unable to remove stage prerequisite.");
                    });
            }
        }


    });
}
